import { render, staticRenderFns } from "./Inspeccion.vue?vue&type=template&id=5b355faa&scoped=true&"
import script from "./Inspeccion.vue?vue&type=script&lang=js&"
export * from "./Inspeccion.vue?vue&type=script&lang=js&"
import style0 from "./Inspeccion.vue?vue&type=style&index=0&id=5b355faa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b355faa",
  null
  
)

export default component.exports